import { useContext } from "react";
import { ExternalLink, Menu as MenuIcon } from "lucide-react";
import { SideMenuContext } from "../../contexts/SideMenuContext";

interface UpperMenuProps { title: string; }

export default function UpperMenu({ title }: UpperMenuProps) {
  const { isSideMenuCollapsed, setIsSideMenuCollapsed } = useContext(SideMenuContext);

  const displayTitle = title === "Plataforma" ? "Visão geral" : title === "Gastos" ? "Consumo" : title;

  return (
    <header className="sticky top-0 z-30 shrink-0 border-b border-border bg-background">
      <div className="flex h-[60px] items-center gap-3 px-4 md:px-6">
        <button
          onClick={() => setIsSideMenuCollapsed(!isSideMenuCollapsed)}
          aria-label="Abrir menu"
          className="flex h-9 w-9 items-center justify-center rounded-full border border-border text-foreground transition-colors hover:border-brand-green hover:text-brand-green md:hidden"
        >
          <MenuIcon className="h-4 w-4" />
        </button>
        <div className="flex min-w-0 flex-1 items-center gap-3 text-xs text-muted-foreground">
          <span className="hidden sm:inline">Plataforma</span><span className="hidden text-muted-foreground/50 sm:inline">/</span><span className="truncate font-medium text-foreground">{displayTitle}</span>

        </div>
        <a
          href="https://status.maritaca.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden items-center gap-1.5 text-[11px] font-medium text-muted-foreground transition-colors hover:text-foreground md:flex"
        >
          Status
          <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    </header>
  );
}
